import React from 'react';

export default ({ color = '#fffff', size = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.49023 4.98429L4.15421 6.64826L7.48216 3.32031" stroke={color} strokeWidth="1.5" strokeLinecap="round"
          strokeLinejoin="round"/>
  </svg>

);
